import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CorteService } from 'src/app/services/corte.service';
import { FormatoData, FormatoService } from 'src/app/services/formato.service';
@Component({
  selector: 'app-formato-fallas',
  templateUrl: './formato-fallas.component.html',
  styleUrls: ['./formato-fallas.component.scss']
})
export class FormatoFallasComponent implements OnInit {

  fallas: any[]=[];
  data$: Observable<FormatoData>;
  finalise = new Subject();
  consecutivo:number=0;

  constructor(
    private formatoService: FormatoService,
    private toastr: ToastrService,
    private corteService: CorteService
  ) {
    this.data$ = formatoService.obtenerData;
  }

  ngOnInit(): void {

    this.data$.pipe(takeUntil(this.finalise)).subscribe( data => {
      if ( data.tipo === 5 ) {
        this.corteService.getFallasCorte( data.id_corte_usuario ).subscribe( fallas => {
          this.fallas = fallas;
          console.log( this.fallas );
        });
      }
      this.finalise.next();
      this.finalise.complete();
    });

  }
}
